






import { Component, Vue } from 'vue-property-decorator';
import { Mutations, ViewModes } from '@/ts/store/Constants';

@Component
export default class AddParticipantButton extends Vue {
    constructor() {
        super();
    }

    get buttonClass() {
        return {
            'hococo-header-button--disabled': (!(this.$store.getters['Messages/isAuthorOfActiveConversation'])),
        };
    }

    public addParticipant() {
        if (this.$store.getters['Messages/isAuthorOfActiveConversation']) {
            this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, ViewModes.Messages.AddPerson);
        }
    }
}
